import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { Layout, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SideBar from '../components/SideBar/SideBar'
import { Content } from 'antd/lib/layout/layout'
import { Footer } from '../components/Footer/Footer'
import { InteractionStatus } from '@azure/msal-browser'
import { useQuery } from '@apollo/client'
import { GET_LOGGED_IN_USER } from '../graphql/query/organization'
import { IUser } from '../modules/OrganizationDetails/types'
import NotFound from '../modules/notFound/notFound'
import { ENotFound } from '../modules/notFound/types'
import Header from '../components/Header/Header'

const ProtectedRoute = (props: any) => {
  const navigate = useNavigate()
  const isLoggedIn = useIsAuthenticated()
  const { inProgress } = useMsal()
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(true)
  const {
    data,
    loading: userDataLoading,
    error: userDataError,
  } = useQuery(GET_LOGGED_IN_USER, {
    skip: !isLoggedIn,
    fetchPolicy: 'network-only',
  })
  const userData: IUser = data?.getLoggedInUser

  const handleSidebarCollapse = () => {
    setIsSidebarCollapsed((prev) => !prev)
  }

  useEffect(() => {
    if (!isLoggedIn && inProgress === InteractionStatus.None) {
      return navigate('/signin')
    }
  }, [isLoggedIn, navigate, inProgress])

  return (
    <React.Fragment>
      {isLoggedIn ? (
        userDataLoading ? (
          <Row align={'middle'} justify={'center'} style={{ width: '100%', padding: 24 }}>
            <Spin size="large" />
          </Row>
        ) : Boolean(userData) ? (
          <>
            <SideBar isActive isCollapsed={isSidebarCollapsed} onCollapse={handleSidebarCollapse} />
            <Layout>
              <Content
                style={{
                  margin: 0,
                  minHeight: 280,
                  marginInlineStart: isSidebarCollapsed ? 60 : 150,
                }}>
                {props.children}
              </Content>
              <Footer />
            </Layout>
          </>
        ) : (
          <>
            <Header />
            <NotFound type={ENotFound.USER} />
          </>
        )
      ) : null}
    </React.Fragment>
  )
}

export default ProtectedRoute
